/**
 * 遊び始めのお知らせを1つずつ順番に出す。
 *
 * 「ようこそ。おはしを3本どうぞ」と「豆知識は、ここから読めます」が同時に出て、
 * 読み上げ（role=status）も2件かさなっていた（2026-10-04 レビュー4）。
 * お知らせはここに並べ、前のが消えてから次を出す。
 */

export interface Notice {
  /** 出す。 */
  show: () => void;
  /** 消す（出しているあいだに別の理由で消えていてもかまわない）。 */
  hide: () => void;
  /** 出しておく時間（ミリ秒）。 */
  durationMs: number;
  /** 出す直前に確かめる。false なら出さずに次へ（例：もう遊んでいない）。 */
  stillWanted?: () => boolean;
}

/** 前のお知らせが消えてから次を出すまでの間（読み上げが続けて流れないように）。 */
export const NOTICE_GAP_MS = 600;

export class NoticeQueue {
  private readonly queue: Notice[] = [];
  private busy = false;

  push(notice: Notice): void {
    this.queue.push(notice);
    this.next();
  }

  /** いま出しているか、待っているお知らせがあるか。 */
  get pending(): boolean {
    return this.busy || this.queue.length > 0;
  }

  private next(): void {
    if (this.busy) return;
    const notice = this.queue.shift();
    if (!notice) return;
    if (notice.stillWanted && !notice.stillWanted()) {
      this.next();
      return;
    }
    this.busy = true;
    notice.show();
    setTimeout(() => {
      notice.hide();
      setTimeout(() => {
        this.busy = false;
        this.next();
      }, NOTICE_GAP_MS);
    }, notice.durationMs);
  }
}

/** 画面ぜんたいで1本の列。 */
export const startupNotices = new NoticeQueue();
